import axios from 'axios'
import {
  GET_DOWNLOAD_LINK
} from '@/store/mutations_types'
import {
  GET_DOWNLOAD_LINK_URL
} from '@/constant/urlConfig'
const actions = {
  getDownloadLink(context, {
    encData,
    pid,
    timestamp
  }) {
    return new Promise(function (resolve, reject) {
      let getDowloadlink = GET_DOWNLOAD_LINK_URL + '?enc_data=' + encData + '&pid=' + pid + '&ver=' + timestamp
      axios.get(getDowloadlink)
        .then(response => {
          context.commit(GET_DOWNLOAD_LINK, response.data)
          resolve(response.data.lang)
        }).catch(error => {
          reject(error)
        })
    })
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/store/modules/Common/action.js